import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import DateRangeCalendar from "../DateRangeCalendar";
import AlertMessage from "../common/alertMessage";

class WebhookFilter extends Component {
  state = {
    filterCriteria: {
      loginName: "",
      applicationId: "",
      webhookId: "",
      fromDate: "",
      toDate: ""
    },
    errorDurationMessage: false,
    dateErrorMessage: "",
    disableSearchButton: false
  };

  searchBtn = () => {};

  handleChange = ({ currentTarget: input }) => {
    const filterCriteria = { ...this.state.filterCriteria };
    filterCriteria[input.name] = input.value.trim();
    this.setState({ filterCriteria });
  };

  showDurationErrorMessageClasses = () => {
    let classes = "form-row ";
    classes += this.state.errorDurationMessage ? "show" : "hide";
    return classes;
  };

  /* Function to handle the dates received from the date range child component */
  selectedDates = dates => {
    if (dates === null) {
      this.setState({ disableSearchButton: false });
      this.setState({ errorDurationMessage: false });
      const filterCriteria = { ...this.state.filterCriteria };
      filterCriteria["fromDate"] = "";
      filterCriteria["toDate"] = "";
      this.setState({ filterCriteria });
      /*let defaultFromDate = moment()
        .subtract(6, "d")
        .format("YYYY-MM-DD");
      let defaultToDate = moment().format("YYYY-MM-DD");
      const filterCriteria = { ...this.state.filterCriteria };
      filterCriteria["fromDate"] = defaultFromDate;
      filterCriteria["toDate"] = defaultToDate;
      this.setState({ filterCriteria });*/

      return;
    }
    if (
      dates[0] === undefined ||
      dates[1] === undefined ||
      dates[0] === "" ||
      dates[1] === ""
    ) {
      this.setState({ disableSearchButton: true });
      return;
    }

    let newFromDate = moment(dates[0]).format("YYYY-MM-DD");
    let newToDate = moment(dates[1]).format("YYYY-MM-DD");

    var a = moment(newFromDate);
    var b = moment(newToDate);
    var c = b.diff(a, "days"); //[days, years, months, seconds, ...]

    if (c >= 7) {
      this.setState({
        dateErrorMessage: "You can't select a duration more than 7 days."
      });
      this.setState({ errorDurationMessage: true });
      this.setState({ disableSearchButton: true });
    } else if (c < 0) {
      this.setState({
        dateErrorMessage: "to Date can't be earlier than from Date."
      });
      this.setState({ errorDurationMessage: true });
      this.setState({ disableSearchButton: true });
    } else if (newFromDate && newToDate && isNaN(c)) {
      this.setState({
        dateErrorMessage:
          "Invalid date format. Please use the correct date format."
      });
      this.setState({ errorDurationMessage: true });
      this.setState({ disableSearchButton: true });
    } else {
      const filterCriteria = { ...this.state.filterCriteria };
      filterCriteria["fromDate"] = newFromDate;
      filterCriteria["toDate"] = newToDate;
      this.setState({ filterCriteria });
      this.setState({ errorDurationMessage: false });
      this.setState({ disableSearchButton: false });
    }
  };

  resetFilterCriteria = () => {
    let filterCriteria = { ...this.state.filterCriteria };
    filterCriteria["loginName"] = "";
    filterCriteria["applicationId"] = "";
    filterCriteria["webhookId"] = "";
    filterCriteria["fromDate"] = "";
    filterCriteria["toDate"] = "";

    this.setState({ filterCriteria });
    this.refs.drc.resetDates();
    this.setState({ errorDurationMessage: false });
    this.setState({ disableSearchButton: false });
    this.props.filter();
  };

  resetErrorMessage = () => {
    this.setState({ errorDurationMessage: false });
  };

  render() {
    return (
      <div>
        <form className="filter-form mt-2 mb-4">
          <div className="form-row">
            <div class="mb-2">
              <span class="txn_lbl_FilterBy">FILTER BY</span>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-2">
              <input
                type="text"
                className="form-control text-truncate"
                placeholder="Webhook ID"
                value={this.state.filterCriteria.webhookId}
                name="webhookId"
                onChange={this.handleChange}
              />
            </div>
            <div className="form-group col-md-2">
              <input
                type="text"
                className="form-control text-truncate"
                placeholder="Login Name"
                name="loginName"
                value={this.state.filterCriteria.loginName}
                onChange={this.handleChange}
              />
            </div>
            <div className="form-group col-md-2">
              <input
                type="text"
                className="form-control text-truncate"
                placeholder="Application ID"
                name="applicationId"
                value={this.state.filterCriteria.applicationId}
                onChange={this.handleChange}
              />
            </div>
            <div className="form-group col-md-3">
              <DateRangeCalendar
                onSelectedDates={this.selectedDates}
                maxDate={new Date()}
                ref="drc"
              />
            </div>
            <div className="form-group col-md-2 text-center">
              <button
                type="button"
                className="btn btn-primary"
                disabled={this.state.disableSearchButton}
                onClick={() => {
                  this.props.filter(
                    this.state.filterCriteria.webhookId,
                    this.state.filterCriteria.loginName,
                    this.state.filterCriteria.applicationId,
                    this.state.filterCriteria.fromDate,
                    this.state.filterCriteria.toDate
                  );
                }}
              >
                <i className="fas fa-search form-control-feedback" />
                &nbsp;Search
              </button>
            </div>
            <div className="form-group col-md-1">
              <Link
                className="font-weight-bold text-center mt-2"
                onClick={this.resetFilterCriteria}
              >
                RESET
              </Link>
            </div>
          </div>
          {this.state.errorDurationMessage && (
            <div className={this.showDurationErrorMessageClasses()}>
              <div className="col-5"></div>
              <div className="col-5">
                <span className="duration-error-message">
                  <AlertMessage
                    message={this.state.dateErrorMessage}
                    alertType="alert-warning"
                    onResetErrorMessage={this.resetErrorMessage}
                  />
                </span>
              </div>
            </div>
          )}
        </form>
      </div>
    );
  }
}
export default WebhookFilter;
